/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingSingleMutationRequest, PostApiBookingSingleMutationResponse, PostApiBookingSingleQueryParams } from "../entities/PostApiBookingSingle";

function getPostApiBookingSingleUrl() {
  const res = { method: 'POST', url: `/api/booking/single` as const }
  return res
}

/**
 * @description Создание новой записи на стрижку
 * @summary Создать запись
 * {@link /api/booking/single}
 */
export async function postApiBookingSingle(data: PostApiBookingSingleMutationRequest, params: PostApiBookingSingleQueryParams, config: Partial<RequestConfig<PostApiBookingSingleMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBookingSingleMutationResponse, ResponseErrorConfig<Error>, PostApiBookingSingleMutationRequest>({ method : "POST", url : getPostApiBookingSingleUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}